import React from 'react';

export const formatTextWithLinebreaks = (str: string) =>
  str.split('\n').map((item: string, index: number) => (
    <React.Fragment key={index}>
      {item}
      <br />
    </React.Fragment>
  ));

export const formatTextAsParagraphs = (str: string) =>
  str
    .split('\n')
    .map((item: string, index: number) => <p key={index}>{item}</p>);
